import { render } from "./BankRestriction.vue?vue&type=template&id=22b26e94&scoped=true"
import script from "./BankRestriction.vue?vue&type=script&lang=js"
export * from "./BankRestriction.vue?vue&type=script&lang=js"

import "./BankRestriction.vue?vue&type=style&index=0&id=22b26e94&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b26e94"]])

export default __exports__